module.exports = __webpack_public_path__ + "static/media/globe-solid.ee441e8b.svg";